<template>
  <view wx:if="{{isCxvip}}" class="container">
    <view class="info">
      <image class="vip-icon" src="{{vipicon}}"></image>
      <view>12306畅行会员</view>
    </view>
    <view class="tip">
      <view>已开通，享候补抢票</view>
    </view>
  </view>
  <view wx:else class="common-container">
    <view class="common-container-info">
      <view class="title">开通12306畅行会员</view>
      <view class="sub-title">开通会员，享受双渠道抢票权益</view>
      <view bindtap="toOpenCxvip" class="open-btn">立即开通</view>
    </view>
    <image class="unvip-icon" src="{{unvipicon}}"></image>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from '@/common/jump'
  import store from '@/store'

  createComponent({
    props: {
        isCxvip: {
            type: Boolean,
        }
    },
    data() {
      return {
        vipicon: 'https://ut-static.udache.com/webx/sfc/fGIdNFcwWcPhvmqm4ovsc_clipboard_image_1696923309475.png',
        unvipicon: 'https://ut-static.udache.com/webx/sfc/7y81ZhEByDQkGAhhzl0fY_clipboard_image_1696929538559.png'
      }
    },
    methods: {
      ...store.mapMutations({
        verifyCxvip: 'login12306.verifyCxvip',
      }),
      toOpenCxvip() {
        this.verifyCxvip(true)
      }
    },
  })
</script>

<style lang='stylus' scoped>
.container
  border-radius 8px
  box-sizing border-box
  height 56px
  background #F8F9FD
  @extend .flex-center
  justify-content space-between
  padding 14px 8px 14px 16px
  margin-top 12px
  font-weight normal
  line-height 1
  letter-spacing 0px
  .info, .tip
    @extend .flex-center
  .info
    font-family PingFangSC-Medium
    font-size 16px
    color #000000
    .vip-icon
      width 28px
      height 28px
      margin-right 8px
  .tip
    font-family PingFangSC-Regular
    font-size 12px
    color #666666
.common-container
  border-radius 8px
  box-sizing border-box
  margin-top 12px
  background #EAF3FF
  height 108px
  display flex
  align-items flex-start
  justify-content space-between
  padding 10px 16px
  &-info
    display flex
    flex-direction column
    align-items flex-start
    justify-content flex-start
    line-height 1
    .title
      font-family PingFangSC-Medium
      font-size 16px
      font-weight normal
      letter-spacing 0px
      color #000000
      margin-top 6px
    .sub-title
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      letter-spacing 0px
      color #3D3D3D
      margin-top 8px
    .open-btn
      width 74px
      height 28px
      @extend .flex-center
      justify-content center
      border-radius 5px
      background-color #338FFF
      color #FFFFFF
      font-family PingFangSC-Medium
      font-size 12px
      font-weight normal
      letter-spacing 0px
      margin-top 12px
  .unvip-icon
    width 90px
    height 90px
</style>

<script name='json'>
  module.exports = {
    component: true,
  }
</script>

